import { dictionary } from '@ember/-internals/utils';

export default dictionary(null);
